import { TarriffSections } from './enumerations/tariff-sections'
import { AlertSections } from './enumerations/alert-sections'
import { ContractTariff } from './entity/shared/ContractTariff'

interface recommendedUsage {
  hourly:number,
  daily:number
}

export class ExtendedContractTariff extends ContractTariff {

  recommendedUsage: recommendedUsage
  section: TarriffSections
  alertSection: AlertSections

  constructor() {
    super()
    this.recommendedUsage = {
      hourly:0,
      daily:0
    }
    this.section = TarriffSections.OVERVIEW
    this.alertSection = AlertSections.RULES_LIST
  }

}